// src/i18n/index.js
import { createI18n } from 'vue-i18n'

// 安全获取 localStorage
let savedLocale = 'zh'
try {
  savedLocale = localStorage.getItem('locale') || 'zh'
} catch (e) {
  console.warn('localStorage not available, using default locale: zh')
}

const messages = {
  zh: {
    freeConsultation: '免费咨询',
    nav: {
      home: '首页',
      servicePattern: '服务模式',
      solution: '解决方案',
      news: '新闻资讯',
      about: '关于我们',
      lowCode: '低代码',
      dataCenter: '数据中台',
      ai: '人工智能'
    },
    home: {
      honor: '公司荣誉',
      solution: '解决方案',
      news: '新闻资讯',
      partner: '合作伙伴',
      technology: '技术生态',
      about: '关于我们',
      viewDetail: '查看详情',
      newsList: '新闻列表',
      backToTop: '回到顶部'
    },
    banner: {
      title1: '助力组织的数字化转型',
      desc1: '完善的应用解决方案，帮助组织构建统一的数字化运营平台',
      title2: '以信息技术推动产业变革',
      desc2: '通过软件与技术的结合，提供完备的行业解决方案',
      title3: '专业软件与信息技术服务提供商',
      desc3: '高新技术、勇于创新、与客户共赢',
      consult: '免费咨询架构师'
    },
    footer: {
      solution: '解决方案',
      lowCodeSolution: '低代码解决方案',
      dataSolution: '数据中台解决方案',
      aiSolution: '人工智能解决方案',
      contact: '联系我们',
      phone: '电话',
      address: '地址',
      detailedAddress: '北京市昌平区北清路TBD云集中心4号楼B座5层',
      email: '邮箱',
      copyright: '版权所有© 北京玲珑塔科技有限公司',
      icp: '京 ICP 备 2021034807 号',
      cloudSupport: '本网站由阿里云提供云计算及安全服务本网站支持',
      ipv6Support: 'IPv6 Powered by CloudDream'
    },
    intro: {
      desc: '公司成立于 2019 年，是专业软件与信息技术服务提供商。我们将客户的实际需要放在首位，充分利用技术专长、领域知识、便捷的交付体系、专业的项目管理，为客户提供技术创新驱动的价值型 IT 服务与解决方案。',
      viewDetail: '查看详情'
    },
    technology: {
      title: '全栈适配国产伙伴产品，打造信创生态体系',
      desc: '从底层 CPU、服务器、中间件、数据库、浏览器到各种文档环境进行全面信创支持，打造全生态信创平台。产品适用于 X86、MIPS、ARM 架构的国产化服务器和桌面机，适配各种国产化操作系统和中间件，具备完整信创解决方案。'
    },
    about: {
      title: '关于我们',
      subtitle: '北京玲珑塔科技有限公司',
      headerTitle: '专业软件与信息技术服务提供商',
      companyIntroTitle: '公司简介',
      companyIntroPart1: '北京玲珑塔科技有限公司（Beijing LinglongTopTechnology Co., Ltd.）成立于 2019 年，是专业软件与信息技术服务提供商。本部位于北京昌平未来科学城辐射圈，在上海、广州、深圳、西安、南京、杭州、苏州设有分支机构和常驻团队。玲珑塔科技始终将客户的实际需求放在首位，凭借技术专长、领域知识、便捷的交付体系、专业的项目管理，为客户提供技术创新驱动的价值型 IT 服务与解决方案。',
      companyIntroPart2: '玲珑塔科技提供涵盖客户业务 IT 生命周期的全方位服务与解决方案，包括：IT 技术咨询、应用开发、产品工程，客户化软件开发、维护与测试，以及业务流程服务，技术人员输出服务。基于对 IT 应用创新的研究、联合社会高新技术企业形成开放式创新联盟，玲珑塔科技具备持续的自主创新和技术研发能力，实践以价值为核心的 IT 服务战略，提供 IT 解决方案和技术人员现场研发服务。',
      companyIntroPart3: '公司发展至今已获得国家级高新企业、双软认证，以及 AAA 级企业信用资质、CMMI5 认证、ISO45001 认证、ITSS3 认证、ISO9001 认证、ISO14001 认证、ISO20000 认证、ISO27001 认证等体系认证，具备为客户提供与国际接轨的过程及质量控制方面的体系化管理能力。',
      companyIntroPart4: '玲珑塔科技拥有独立的产品研发团队和项目人力服务团队。成立至今获得 16 项核心软著等知识产权产品。目前公司自研的低代码平台和数据中台已经上线，未来会持续投入实际应用，全面提升项目效率和质量。',
      cultureMission: '使命',
      cultureMissionDesc: '用新的方法，在当前时代下，打造一家灵活快速、可持续良性运转的公司',
      cultureVision: '愿景',
      cultureVisionDesc1: '成为客户最值得信赖的专业化信息技术服务提供商',
      cultureVisionDesc2: '成为员工最值得依靠的，以信息技术为基础生产力的组织',
      cultureValues: '价值观',
      cultureValuesDesc: '诚信为本、忠于托付',
      honors: '荣誉奖项',
      partnerTitle: '与更多优秀企业一起高速成长',
      recruitTitle: '我们和伟大之间，就差一个你',
      recruitEmail: '简历请投递至：'
    },
    servicePattern: {
      title: '服务模式',
      subtitle: '全方位的服务体系，满足客户多样化需求',
      softwareTest: '软件测试服务',
      softwareTestDesc: '提供全面的软件测试解决方案，包括功能测试、性能测试、安全测试等',
      consulting: '技术咨询',
      consultingDesc: '专业的技术咨询服务，帮助企业制定技术发展战略',
      development: '定制开发',
      developmentDesc: '根据客户需求提供定制化软件开发服务',
      maintenance: '运维支持',
      maintenanceDesc: '7x24 小时运维支持，保障系统稳定运行',
      learnMore: '了解更多'
    },
    tone: {
      title: '低代码平台',
      subtitle: '快速构建企业级应用，加速数字化转型',
      intro: '平台介绍',
      introDesc: '玲珑塔低代码平台提供可视化开发环境，让应用开发更高效',
      features: '产品特性',
      featuresList: ['可视化拖拽开发', '丰富的组件库', '灵活的工作流引擎', '多端适配'],
      advantages: '核心优势',
      advantagesList: ['开发效率提升 80%', '降低技术门槛', '快速响应业务变化', '降低开发成本'],
      scenarios: '应用场景',
      scenariosList: ['企业 OA 系统', 'CRM 客户管理', 'ERP 资源规划', '数据报表系统'],
      contact: '立即咨询'
    },
    datacenter: {
      title: '数据中台',
      subtitle: '数据驱动业务创新，释放数据价值',
      intro: '平台介绍',
      introDesc: '一站式数据中台解决方案，实现数据资产化管理',
      features: '产品特性',
      featuresList: ['数据集成', '数据治理', '数据服务', '数据分析'],
      advantages: '核心优势',
      advantagesList: ['统一数据标准', '提升数据质量', '加速数据应用', '降低数据成本'],
      scenarios: '应用场景',
      scenariosList: ['数据仓库建设', '数据资产管理', '数据服务开放', '智能数据分析'],
      contact: '立即咨询'
    },
    ai: {
      title: '人工智能',
      subtitle: 'AI 赋能企业智能化升级',
      intro: '平台介绍',
      introDesc: '提供全方位的 AI 解决方案，助力企业智能化转型',
      features: '产品特性',
      featuresList: ['虚拟数字人', '智能语音交互', 'AI 中台', '智能文档处理'],
      advantages: '核心优势',
      advantagesList: ['成熟的 AI 算法', '快速部署应用', '灵活的定制能力', '持续的技术支持'],
      scenarios: '应用场景',
      scenariosList: ['智能客服', '智能会议', '智慧招聘', '智能核算'],
      contact: '立即咨询'
    },
    news: {
      title: '新闻资讯',
      subtitle: '了解公司最新动态和行业资讯',
      list: '新闻列表',
      detail: '新闻详情',
      back: '返回列表',
      publishTime: '发布时间',
      source: '来源',
      share: '分享',
      relatedNews: '相关新闻',
      noMore: '没有更多了'
    },
    reservation: {
      title: '预约咨询',
      subtitle: '免费获取专业建议，我们的专家将为您解答',
      name: '姓名',
      namePlaceholder: '请输入您的姓名',
      phone: '手机号',
      phonePlaceholder: '请输入您的手机号',
      company: '公司名称',
      companyPlaceholder: '请输入您的公司名称',
      email: '邮箱',
      emailPlaceholder: '请输入您的邮箱',
      requirement: '需求描述',
      requirementPlaceholder: '请描述您的具体需求',
      verifyCode: '验证码',
      verifyCodePlaceholder: '请输入验证码',
      refreshCode: '刷新验证码',
      submit: '提交',
      cancel: '取消',
      success: '提交成功，我们将尽快与您联系',
      error: '提交失败，请重试'
    },
    contact: {
      title: '联系我们',
      subtitle: '随时欢迎您的咨询',
      phone: '联系电话',
      email: '电子邮箱',
      address: '公司地址',
      message: '在线留言',
      messagePlaceholder: '请输入您想咨询的内容',
      send: '发送',
      officeHours: '工作时间',
      officeHoursDesc: '周一至周五 9:00-18:00'
    },
    common: {
      submit: '提交',
      cancel: '取消',
      confirm: '确认',
      back: '返回',
      loading: '加载中...',
      success: '操作成功',
      error: '操作失败',
      required: '必填项',
      placeholder: '请输入',
      viewDetail: '查看详情',
      learnMore: '了解更多',
      contactUs: '联系我们'
    },
    servicePatternText:{
      title: '服务模式',
      section1: {
        title: '咨询服务模式',
        cards: [
          {
            title: '方案式咨询',
            text: '根据企业要求深入调研了解企业的基本情况，甄别企业管理核心问题，运用专业知识有针对性为企业提供解决问题咨询方案'
          },
          {
            title: '辅导式咨询',
            text: '通过我们的专业咨询师进驻企业，全程辅导企业进行管理工作，手把手地教，为企业全面导入科学化的管理模式，提升企业管理团队的专业能力'
          },
          {
            title: '托管式咨询',
            text: '根据企业委托，派驻专业化经营团队，在遵循企业管理价值要求的基础上，代理企业经营管理，辅助企业确定一套科学系统的管理模式，提高企业管理效率'
          }
        ]
      },
      section2: {
        title: '实施服务模式',
        subTitle: '软件定制开发服务',
        text1: '为了满足企业的个性化业务需求，玲珑塔科技为企业提供专业的软件定制开发服务，满足企业软件产品的不同需求，同时也为客户提供高品质的软件外包服务。',
        text2: '经过多年的软件开发经验的积累，玲珑塔科技在金融、流通、零售、教育、旅游等行业为客户提供优质的定制开发外包服务，并且形成了一整套成熟的软件项目开发流程和质量保证体系，保证了软件开发的高效和高品质并按时交付。'
      },
      section3: {
        title: '软件开发业务流程',
        steps: [
          { num: '01', title: '需求调研分析', text: '客户提出需求并进行需求分析，和客户反复确认需求，提交初步设计' },
          { num: '02', title: '系统设计', text: '对软件进行概要设计，并在概要设计的基础上进行详细设计，生成设计文档供开发人员进行开发' },
          { num: '03', title: '系统开发', text: '根据详细设计文档开始对软件进行功能开发，从而实现对目标系统的功能、接口、界面等需求' },
          { num: '04', title: '系统测试', text: '项目组完成系统的单元测试、向客户提交测试据告，然后交给客户试用' },
          { num: '05', title: '软件交付', text: '经测试满意后，向客户提交所有双方合同约定的产物，包括源代码、设计报告、测试报告、安装手册、使用指南等' },
          { num: '06', title: '用户验收', text: '用户根据需求文档及标书验收，收尾结算' }
        ]
      },
      section4: {
        title: '定制开发服务范围',
        tabs: ['B/S 软件定制开发', '微信开发', '手机应用软件开发'],
        cards: [
          { title: 'B/S 软件定制开发', text: '专业定制各类软件，包括运维管理系统、OA 办公系统、CRM 系统、资产管理系统、考试管理系统、学校招生系统等' },
          { title: '微信开发', text: '专业定制微信公众号 (企业号/服务号)、微信小程序，微官网、微商城、微信支付功能、微信接口等开发定制' },
          { title: '手机应用软件开发', text: 'IOS、Android APP 开发，iPhone、iPad、Android 手机 Android 平板，APP 原生开发，HtmI5 开发、手机端网站开发等' }
        ],
        tryFree: '免费试用'
      },
      section5: {
        title: '软件测试服务'
      },
      section6: {
        title: '运营服务模式',
        subTitle: '离岸研发中心（ODC）运营',
        text1: '以外派工单的升级形式，在双方建立一段合作和信任之后，可以让我们在自主场地进行任务工单的开发。对企业而言，这会降低远程管理成本，还可以相应降低工单报价。',
        text2: '玲珑塔科技的 ODC 是根据严格的国际化安全标准和客户内部对人员、数据、基础设施、知识产权等方面的相关政策要求搭建的，目的在于最大限度的确保客户的知识产权得到最高级别的安全保护。',
        cards: [
          {
            title: '由客户管理的 ODC',
            text: '在这种模式中，我们提供项目经理，程序员和所需的硬件设施。客户方负责软件架构设计和管理整个软件的开发过程。在开发过程中，我们会根据开发的需要要求客户提供相关的商业信息，商业流程，质量管理，技术资源等相关信息。这种 ODC 模式是建立在双方的合作伙伴关系基础上的，需要双方全心全意地奉献'
          },
          {
            title: '由我们负责管理的 ODC',
            text: '这种模式，只需要客户公司提出需求，由我们为您提供需求分析，完成解决方案的设计，并完成后期的全部开发以及测试，直到项目成功交付客户使用。我们在整个开发过程中，不但提供技术人员，硬件设备，而且负责全面的管理'
          },
          {
            title: '建设、运营和移交模式的 ODC',
            text: '在这种模式中，我们在双方协议的基础上按照客户的要求建立一个 ODC, 其中包括硬件设施的购买，软件技术人员的招聘和培训，并对这个 ODC 进行一段时期的管理。当客户准备就绪，这个 ODC 将被转交给客户进行独立管理，其中包括全部的设备，技术人员和我方的管理经验'
          }
        ]
      },
      softwareTest:[
        {
          title: '功能测试',
          tests: ['功能验证测试', '逆向测试', '流程测试', '容错性测试']
        },
        {
          title: '性能效率测试',
          tests: ['负载测试', '压力测试', '疲劳强度测试', '并发测试']
        },
        {
          title: '安全性测试',
          tests: ['保密性', '完整性', '可核查性', '真实性', '抗抵赖性']
        },
        {
          title: '可靠性测试',
          tests: ['成熟性', '可用性', '容错性', '已恢复性']
        },
        {
          title: '其他测试',
          tests: ['兼容性测试', '易用性测试', '维护性测试', '可移植性测试', '文档测试']
        }
      ]
    },
    tonePage:{
      section1: {
        title: 'Tone 智能开发平台',
        description: '基于玲珑塔科技深度探索的大规模参数和深度学习能力的智能模型底座，Tone 为企业提供更加智能化的软件生产方式，IT 人员可以轻易实现从"智能生成"到"可视化拖拽调整"的全栈低代码应用搭建，让复杂应用开发更加高效，加快企业数字化与智能化进程。',
        consultBtn: '免费咨询架构师'
      },
      section2: {
        title: '业务数智化，皆可低代码',
        cards: [
          {
            title: '智能编程',
            text: '机器学习是智能编程的关键技术之一。通过机器学习，计算机可以逐步学习开发者的意图和需求，从而更好地理解用户所表达的代码要求。这样，开发者只用简洁的自然语言描述自己的需求，智能编程系统会自动为其生成相应的代码。'
          },
          {
            title: '智能交互',
            text: '提供智能交互组件，利用自然语言生成代码技术，让用户做到即时智能查询、流畅智能交互、引领智能创新体验。'
          }
        ]
      },
      section3: {
        title: '改变企业软件生产方式',
        consultBtn: '免费咨询架构师',
        stats: [
          { percent: '60%', label1: '降低', label2: '全环节软件开发成本' },
          { percent: '50%', label1: '平均缩短', label2: '项目交付周期' }
        ]
      },
      section4: {
        title: '低代码 VS 零代码'
      },
      section5: {
        title: '为什么选择 Tone 智能开发平台',
        cards: [
          {
            title: '高保真还原交互视觉需求',
            text: '开放性使其具备更高的客制化能力，可以高保真还原交互视觉要求，突破企业自定义需求开发受限等难题'
          },
          {
            title: '可集成性高',
            text: '支持集成对接客户自有或第三方的数据库、文件存储、认证源、API 等，可以实现应用开发资产互通互联，打通低代码平台和企业软件生态的壁垒'
          },
          {
            title: '可拓展性强',
            text: '支持通过自定义扩展组件或区块、开发新组件、替换组件库等方式灵活拓展平台能力'
          },
          {
            title: '金融级安全要求',
            text: '提供应用源码，无黑盒式引擎，确保应用的代码级安全'
          },
          {
            title: '擅长复杂应用开发',
            text: '提供大量标准化组件以及完备的逻辑组件和流程框架，帮助大中型企业低成本、快速构建关键应用和复杂核心系统'
          },
          {
            title: '支持应用导出',
            text: '提供应用导出与独立部署能力，支持将应用源代码导出，并脱离平台部署到其他环境'
          }
        ]
      },
      section6: {
        title: '产品核心功能',
        tabs: ['页面设计', '流程设计', '表单设计', '接口集成'],
        cards: [
          {
            title: '页面设计',
            text: '可自定义页面样式风格、展示应用所有表单数据，灵活实现信息展示、导航、门户页面等场景'
          },
          {
            title: '流程设计',
            text: '集成流程引擎支持 BPMN2.0 规范下的业务流程开发，并已经进行了模型和符号的标准化，它能够快速开发常见的企业内部流程，如请假、入职、离职等。'
          },
          {
            title: '表单设计',
            text: '丰富的字段类型，强大的数据联动，关联表单，公式运算等能力，实现灵活的低代码可视化设计和页面搭建'
          },
          {
            title: '接口集成',
            text: '企业存量接口可以在低代码平台快速导入，并自动接入 API 网关。该平台提供了可视化的接口定义功能，能够自动将接口接入 API 网关。'
          }
        ],
        tryFree: '免费试用'
      },
      section7: {
        title: '热门应用场景',
        cards: [
          {
            title: '组件/服务沉淀及复用',
            text: '对企业核心的业务进行科学梳理，前端组件库和领域服务得到了高质量的沉淀，形成有效的资产管理，从而实现降本增效'
          },
          {
            title: '扩展核心系统功能',
            text: '通过 API 网关提供灵活的应用集成扩展能力，可以降低维护和实施的技术难度，保证系统的延续性和稳定性，保障软件质量'
          },
          {
            title: '业务流程自动化',
            text: '提供标准工作流引擎，实现业务流程自动化，可提高团队内部协作效率，降低企业成本，打造良好的用户体验，提升用户满意度'
          },
          {
            title: '业务预演/可行性分析',
            text: '基于企业已有业务能力快速进行组合和扩展，并根据市场反馈及时、快速、灵活地调整业务，验证业务创新是否可靠'
          }
        ]
      },
      section8: {
        title: '选择玲珑塔科技，快速搭建企业低代码应用',
        consultBtn: '免费咨询架构师'
      }
    },
    dataCenterPage: {
      section1: {
        title: '数据中台解决方案',
        description: '玲珑塔科技经过多年实践打磨，打造了一个企业级数据中台全链路解决方案，该解决方案结合了优秀的方法论和领先的产品能力，致力于帮助企业进行数字化转型，充分发挥数据的价值，提高企业的数据生产力。',
        consultBtn: '免费咨询架构师'
      },
      section2: {
        title: '方案特色',
        cards: [
          {
            title: '统一数据标准',
            text: '消除数据的二义性，采用数据标准体系建设方法论和数据指标系统相结合的方法，统一数据指标口径'
          },
          {
            title: '统一数据服务',
            text: '统一对外的数据服务接口，将所有的数据服务都整合在一个接口中'
          },
          {
            title: '统一数据资产管理',
            text: '提供适用于企业的数据资产管理平台，通过数据地图和数据血缘功能，实现对数据全链路的 360°追踪'
          },
          {
            title: '统一开发平台',
            text: '提供可视化、拖拽式自助开发与分析平台，统一数据开发流程与项目周期管理提供可视化、拖拽式自助开发与分析'
          }
        ]
      },
      section3: {
        title: '方案架构'
      },
      section4: {
        title: '核心功能',
        tabs: ['敏捷开发平台', '统一查询服务', '数据资产管理', '数据质量中心'],
        cards: [
          {
            title: '敏捷开发平台',
            text: '我们提供一站式的大数据管理与应用开发平台，可满足企业级大数据应用场景的各种需求，包括大规模数据的存储计算、数据集成、任务开发、分析查询、数据管理和项目管理等功能。'
          },
          {
            title: '统一查询服务',
            text: '我们提供易于使用、成本低廉、稳定可靠的数据开放共享服务，以帮助前台业务快速接入。'
          },
          {
            title: '数据资产管理',
            text: '对项目、人员、任务、表、队列的计算和存储资源消耗进行全面的监控和记录。对资源进行清点和规划，以降低数据管理成本并追踪数据的价值。'
          },
          {
            title: '数据质量中心',
            text: '为了提升企业的数据质量，我们需要围绕着完整性、准确性、一致性和及时性进行监控和分析。关注数据接入、数据加工、数据导出、指标和数据应用的全链路血缘跟踪，以便提前预判数据能否准时产出，了解任务失败后影响分析以及快速地修复。'
          }
        ],
        tryFree: '免费试用'
      },
      section5: {
        title: '方案价值',
        cards: [
          {
            title: '提升数据服务效率',
            text: '可实现需求交付速度、数据查找效率、数据查询能力的三重提升'
          },
          {
            title: '提升数据质量',
            text: '实现任务数据的零延迟，同时大幅减少研发 BUG 的数量，并完成数据指标口径的统一'
          },
          {
            title: '降低数据服务成本',
            text: '可大幅度节约业务成本，提升整体研发业务价值'
          },
          {
            title: '保障业务数据安全',
            text: '通过全链路权限管控、自动审批流程、自动风险识别、智能数据脱敏等数据管理措施来确保业务数据的安全'
          }
        ]
      },
      section6: {
        title: '结合业务需求，进一步了解方案详情',
        consultBtn: '免费咨询架构师'
      }
    },
    aiPage: {
      section1: {
        title: '人工智能解决方案',
        description: '本平台通过高性能计算架构和大数据底层平台构建，旨在为 AI 开发者提供一站式、高性能的分析建模平台。平台功能涵盖了算法开发、模型训练评估以及在线推理预测建模的全流程。它能够有效地支持各种数据智能化分析场景，为企业的 AI 转型升级提供有力支持。',
        consultBtn: '免费咨询架构师'
      },
      section2: {
        title: '深入研究算法建模场景，<br/> 为企业提供全方位的 AI 转型升级支持',
        cards: [
          {
            title: '模型工程化复杂',
            painPoint: '在传统的模式下，建模人员完成模型训练后，需要协调工程化团队来完成模型的部署工作，这导致了建模的整体成本较高',
            solution: '机器学习平台简化了任务调度和模型部署等工程事务，只需点击一次即可完成模型部署，实现快速将训练模型应用到业务中，节省成本并提高效率'
          },
          {
            title: '计算效率低',
            painPoint: '在海量数据场景下，AI 分析师通常在专注于业务效率的建模过程中忽略了对硬件和计算框架的考虑，导致模型训练效率下降',
            solution: '我们的机器学习平台整合了 TensorFlow、Spark 等分布式计算框架，并深度优化以满足大规模稀疏化等场景的需求，提供高效的建模能力'
          },
          {
            title: '统一数据资产管理',
            painPoint: '机器学习建模的过程非常复杂，它不仅需要对算法原理有深入的理解，还需要对业务进行深入的研究，传统的数据分析师很难快速胜任',
            solution: '机器学习平台具备易上手的可视化建模功能，将复杂的算法抽象成算子，支持拖拽式交互，能迅速构建建模过程'
          }
        ],
        labels: {
          painPoint: '痛点描述',
          solution: '方案及特色'
        }
      },
      section3: {
        title: '产品优势',
        cards: [
          {
            title: '一站式建模',
            text: '提高建模效率，提供一站式解决方案，覆盖数据管理、特征工程、模型开发调试、离线模型训练和在线模型推理建模'
          },
          {
            title: '高性能计算',
            text: '我们将 Pytorch、Spark、TensorFlow 等计算框架集成并进行优化，同时内置场景化算子，以有效支持广告、推荐等场景应用'
          },
          {
            title: '低推理延时',
            text: '利用网络带宽和后端引擎计算能力，充分实现毫秒级别的精确排名模型计算，以满足推荐、搜索等需要低延时的场景'
          },
          {
            title: '低门槛建模',
            text: '为了满足用户的编程习惯，我们对模型调度、模型版本更新和模型监控等功能进行了封装，以帮助用户更快速地进行模型调优和发布生产'
          }
        ]
      },
      section4: {
        title: '热门应用场景',
        tabs: ['时序预测', '营销推荐', '运营决策优化'],
        cards: [
          {
            title: '时序预测',
            text: '时序类预测场景是智能决策的必要条件和基础。我们利用历史数据，充分挖掘相关因素的关联性，洞察时序的趋势和周期等规律，通过应用时序预测算法进行趋势预测，帮助业务在运营风险出现之前就做出规避措施。'
          },
          {
            title: '营销推荐',
            text: '通过整合用户信息、订单信息、物流信息、商品信息和实时点击行为等数据集，我们可以建立人员 360°画像。通过这个画像，实现对用户兴趣和商品标签的准确匹配，从而召回有效的商品集合，对召回的结果进行细化的商品排序，以实现在互联网场景下的定制化商品营销。'
          },
          {
            title: '运营决策优化',
            text: '以供应链决策优化为例，我们可以将仓储配址、运输调度、库存策略、订单补货策略和供应链整体运筹优化等抽象为建模过程，通过基于平台的建模和计算能力，提高业务决策的智能水平，实现企业的精细化管理。'
          }
        ],
        tryFree: '免费试用'
      },
      section5: {
        title: '核心能力',
        cards: [
          {
            title: '可视化建模',
            text: '将建模的过程抽象成算子，使用户可以通过拖拽式交互构建建模流程。同时，支持实验级别的管控，以实现团队协作的建模'
          },
          {
            title: '数据管理',
            text: '一个统一的数据管理中心，可以管理各种不同来源的数据，包括结构化数据和非结构化数据，并且支持数据采集、数据标注和数据洞察等功能'
          },
          {
            title: '在线推理预测',
            text: '提供在线环境预测服务，能够快速部署离线模型，并提供高并发、低延迟的推理服务。同时，还支持模型平滑升级、弹性扩缩容以及模型失效监测等功能'
          },
          {
            title: '交互式建模',
            text: '提供沉浸式编程体验的模型开发环境，支持 TensorFlow、PyTorch、Spark 等计算框架，支持一键提交训练任务'
          }
        ]
      },
      section6: {
        title: '依托 AI 大模型技术，帮助业务更快、更便捷、更智能地挖掘数据价值',
        consultBtn: '免费咨询架构师'
      }
    },
    homeScheme: {
      solution: '解决方案',
      solutionText: 'SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION',
      cards: [
        {
          title: '低代码',
          content: '玲珑塔科技拥独立的产品研发团队，经过大规模客户验证已占据行业先进地位。提供可直接实施的优质打包应用，在降低需求风险和开放成本的情况下，获得更高满意度。利用先进的低代码（Low-Code）可视化技术，可以在几周内构建高体验新应用，加速企业的运营创新和数字化转型。',
          viewDetail: '查看详情',
          link: '/option/tone'
        },
        {
          title: '数据服务中心',
          content: '数据服务中心集一站式、智能化、平台化、服务化于一体，旨在利用大数据平台的计算、存储和扩容能力，帮助机构实现数据高度整合与数字化建设过程中的数据能力复用，并围绕夯平台、治数据、建服务、触场景四大方向，助力企业数智化转型，实现从业务数据化到数据服务化的全过程。',
          viewDetail: '查看详情',
          link: '/option/datacenter'
        },
        {
          title: '人工智能',
          content: '基于 AI 技术，提供适用于多种场景的企业智能解决方案，包括：虚拟数字人、语言智能控制、AI 中台、大屏幕调优、数据中台、采集采购智能云评审、智能会议、智慧工牌、智能合比对核算等数字化解决方案；智慧招聘、电子合同、智能翻译、智能核算、AI 字幕等。',
          viewDetail: '查看详情',
          link: '/option/ai'
        }
      ]
    },
    reservationPage: {
      company: {
        name: '玲珑塔科技',
        subtitle: '企业数字化转型加速器',
        features: ['高新技术', '勇于创新', '与客户共赢']
      },
      form: {
        title: '获取解决方案',
        description: '感谢选择玲珑塔科技，我们会安排专业的顾问和您演示产品，以减少摸索软件的时间。请填写下方信息，开启高效工作之道。',
        fields: {
          designation: {
            placeholder: '您的姓名（必填）',
            required: '姓名不能为空.'
          },
          companyName: {
            placeholder: '企业名称（必填）',
            required: '企业名称不能为空.'
          },
          duties: {
            placeholder: '您的职务（必填）',
            required: '职务不能为空.'
          },
          phone: {
            placeholder: '您的手机（必填）',
            required: '手机号码不能为空.',
            invalid: '请输入有效的手机号码.'
          },
          leaveMessage: {
            placeholder: '请在此输入留言内容，我们会尽快与您联系',
            required: '请输入您的留言信息.'
          }
        },
        submit: '提 交'
      }
    },
    newsPage: {
      pageTitle: '新闻资讯',
      viewMore: '查看更多',
      noData: '--'
    }
  },
  en: {
    freeConsultation: 'Free Consultation',
    nav: {
      home: 'Home',
      servicePattern: 'Service Pattern',
      solution: 'Solutions',
      news: 'News',
      about: 'About Us',
      lowCode: 'Low Code',
      dataCenter: 'Data Center',
      ai: 'AI'
    },
    home: {
      honor: 'Corporate Honor',
      solution: 'Solutions',
      news: 'News & Events',
      partner: 'Partners',
      technology: 'Technology',
      about: 'About Us',
      viewDetail: 'View Details',
      newsList: 'News List',
      backToTop: 'Back to Top'
    },
    banner: {
      title1: 'Empowering Digital Transformation of Organizations',
      desc1: 'Comprehensive application solutions to help organizations build unified digital operation platforms',
      title2: 'Driving Industrial Change with Information Technology',
      desc2: 'Providing complete industry solutions through the combination of software and technology',
      title3: 'Professional Software and Information Technology Service Provider',
      desc3: 'High-tech, Innovative, Win-win with Customers',
      consult: 'Free Consultation with Architect'
    },
    footer: {
      solution: 'Solutions',
      lowCodeSolution: 'Low Code Solutions',
      dataSolution: 'Data Middle Platform Solutions',
      aiSolution: 'AI Solutions',
      contact: 'Contact Us',
      phone: 'Phone',
      address: 'Address',
      detailedAddress: 'Building 4, Block B, 5th Floor, TBD Yunji Center, Beiqing Road, Changping District, Beijing Municipality',
      email: 'Email',
      copyright: 'Copyright© Beijing Linglongta Technology Co., Ltd.',
      icp: 'ICP No. 2021034807',
      cloudSupport: 'This website is supported by Alibaba Cloud',
      ipv6Support: 'IPv6 Powered by CloudDream'
    },
    intro: {
      desc: 'Founded in 2019, we are a professional software and information technology service provider. We prioritize customer needs and leverage technical expertise, domain knowledge, efficient delivery systems, and professional project management.',
      viewDetail: 'View Details'
    },
    technology: {
      title: 'Full-stack Adaptation of Domestic Products, Building Innovation Ecosystem',
      desc: 'Comprehensive support from CPU, server, middleware, database, browser to various document environments. Products are suitable for X86, MIPS, ARM architecture domestic servers and desktops.'
    },
    about: {
      title: 'About Us',
      subtitle: 'Beijing Linglongta Technology Co., Ltd.',
      headerTitle: 'Professional Software and Information Technology Service Provider',
      companyIntroTitle: 'Company Introduction',
      companyIntroPart1: 'Beijing LinglongTopTechnology Co., Ltd. was founded in 2019 and is a professional software and information technology service provider. Headquartered in Beijing Changping Future Science City radiation zone, with branches and resident teams in Shanghai, Guangzhou, Shenzhen, Xi\'an, Nanjing, Hangzhou, and Suzhou. Linglongta Technology always puts customer needs first, relying on technical expertise, domain knowledge, efficient delivery systems, and professional project management to provide customers with technology innovation-driven value IT services and solutions.',
      companyIntroPart2: 'Linglongta Technology provides comprehensive services and solutions covering the entire IT lifecycle of customer business, including: IT technical consulting, application development, product engineering, customized software development, maintenance and testing, as well as business process services and technical personnel output services. Based on research on IT application innovation and forming an open innovation alliance with high-tech enterprises in the society, Linglongta Technology has continuous independent innovation and technical R&D capabilities, practices IT service strategy with value as the core, and provides IT solutions and technical personnel on-site R&D services.',
      companyIntroPart3: 'The company has obtained national high-tech enterprise certification, dual software certification, AAA enterprise credit qualification, CMMI5 certification, ISO45001 certification, ITSS3 certification, ISO9001 certification, ISO14001 certification, ISO20000 certification, ISO27001 certification and other system certifications. It has the ability to provide customers with process and quality control management capabilities that are in line with international standards.',
      companyIntroPart4: 'Linglongta Technology has an independent product R&D team and project human resources service team. Since its establishment, it has obtained 16 core software copyright and other intellectual property products. Currently, the company\'s self-developed low-code platform and data center have been launched, and will continue to be invested in practical applications in the future to comprehensively improve project efficiency and quality.',
      cultureMission: 'Mission',
      cultureMissionDesc: 'With new methods, build a flexible, fast, and sustainably well-functioning company in the current era',
      cultureVision: 'Vision',
      cultureVisionDesc1: 'Become the most trusted professional information technology service provider for customers',
      cultureVisionDesc2: 'Become the organization that employees can rely on most, with information technology as the basic productivity',
      cultureValues: 'Values',
      cultureValuesDesc: 'Integrity-based, loyal to trust',
      honors: 'Honors & Awards',
      partnerTitle: 'Grow rapidly with more excellent enterprises',
      recruitTitle: 'Between us and greatness, we just need you',
      recruitEmail: 'Please send your resume to:'
    },
    servicePattern: {
      title: 'Service Pattern',
      subtitle: 'Comprehensive service system to meet diverse customer needs',
      softwareTest: 'Software Testing',
      softwareTestDesc: 'Comprehensive software testing solutions including functional, performance, and security testing',
      consulting: 'Technical Consulting',
      consultingDesc: 'Professional technical consulting services to help enterprises develop technology strategies',
      development: 'Custom Development',
      developmentDesc: 'Customized software development services based on customer requirements',
      maintenance: 'Operation Support',
      maintenanceDesc: '7x24 operation support to ensure system stability',
      learnMore: 'Learn More'
    },
    tone: {
      title: 'Low Code Platform',
      subtitle: 'Build enterprise applications quickly, accelerate digital transformation',
      intro: 'Introduction',
      introDesc: 'Linglongta Low Code Platform provides a visual development environment for more efficient application development',
      features: 'Features',
      featuresList: ['Visual drag-and-drop development', 'Rich component library', 'Flexible workflow engine', 'Multi-terminal adaptation'],
      advantages: 'Advantages',
      advantagesList: ['80% development efficiency improvement', 'Lower technical threshold', 'Quick response to business changes', 'Reduced development costs'],
      scenarios: 'Use Cases',
      scenariosList: ['Enterprise OA System', 'CRM Customer Management', 'ERP Resource Planning', 'Data Reporting System'],
      contact: 'Contact Us'
    },
    datacenter: {
      title: 'Data Center',
      subtitle: 'Data-driven business innovation, unlock data value',
      intro: 'Introduction',
      introDesc: 'One-stop data center solution for data asset management',
      features: 'Features',
      featuresList: ['Data Integration', 'Data Governance', 'Data Services', 'Data Analytics'],
      advantages: 'Advantages',
      advantagesList: ['Unified data standards', 'Improved data quality', 'Accelerated data applications', 'Reduced data costs'],
      scenarios: 'Use Cases',
      scenariosList: ['Data Warehouse Construction', 'Data Asset Management', 'Data Service Opening', 'Intelligent Data Analysis'],
      contact: 'Contact Us'
    },
    ai: {
      title: 'Artificial Intelligence',
      subtitle: 'AI-powered enterprise intelligence upgrade',
      intro: 'Introduction',
      introDesc: 'Comprehensive AI solutions to help enterprises achieve intelligent transformation',
      features: 'Features',
      featuresList: ['Virtual Digital Human', 'Intelligent Voice Interaction', 'AI Platform', 'Intelligent Document Processing'],
      advantages: 'Advantages',
      advantagesList: ['Mature AI algorithms', 'Quick deployment', 'Flexible customization', 'Continuous technical support'],
      scenarios: 'Use Cases',
      scenariosList: ['Intelligent Customer Service', 'Smart Meeting', 'Smart Recruitment', 'Intelligent Accounting'],
      contact: 'Contact Us'
    },
    news: {
      title: 'News & Events',
      subtitle: 'Learn about company updates and industry insights',
      list: 'News List',
      detail: 'News Detail',
      back: 'Back to List',
      publishTime: 'Publish Time',
      source: 'Source',
      share: 'Share',
      relatedNews: 'Related News',
      noMore: 'No more news'
    },
    reservation: {
      title: 'Reservation',
      subtitle: 'Get free professional advice, our experts will answer your questions',
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      phone: 'Phone',
      phonePlaceholder: 'Please enter your phone number',
      company: 'Company',
      companyPlaceholder: 'Please enter your company name',
      email: 'Email',
      emailPlaceholder: 'Please enter your email',
      requirement: 'Requirement',
      requirementPlaceholder: 'Please describe your specific requirements',
      verifyCode: 'Verification Code',
      verifyCodePlaceholder: 'Please enter verification code',
      refreshCode: 'Refresh Code',
      submit: 'Submit',
      cancel: 'Cancel',
      success: 'Submitted successfully, we will contact you soon',
      error: 'Submission failed, please try again'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Welcome to contact us anytime',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      message: 'Message',
      messagePlaceholder: 'Please enter your inquiry',
      send: 'Send',
      officeHours: 'Office Hours',
      officeHoursDesc: 'Monday to Friday 9:00-18:00'
    },
    common: {
      submit: 'Submit',
      cancel: 'Cancel',
      confirm: 'Confirm',
      back: 'Back',
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      required: 'Required',
      placeholder: 'Please enter',
      viewDetail: 'View Details',
      learnMore: 'Learn More',
      contactUs: 'Contact Us'
    },
    servicePatternText:{
      title: 'Service Pattern',
      section1: {
        title: 'Consulting Service Pattern',
        cards: [
          {
            title: 'Solution Consulting',
            text: 'Conduct in-depth research to understand the basic situation of the enterprise, identify core management issues, and provide targeted consulting solutions using professional knowledge'
          },
          {
            title: 'Guidance Consulting',
            text: 'Our professional consultants will be stationed in the enterprise to guide the management work, teach hand-by-hand, comprehensively introduce scientific management models, and improve the professional capabilities of the enterprise management team'
          },
          {
            title: 'Trusteeship Consulting',
            text: 'According to the enterprise entrustment, dispatch a professional management team to manage the enterprise on behalf of the enterprise, assist the enterprise to determine a scientific and systematic management model, and improve enterprise management efficiency'
          }
        ]
      },
      section2: {
        title: 'Implementation Service Pattern',
        subTitle: 'Software Custom Development Service',
        text1: 'In order to meet the personalized business needs of enterprises, Linglongta Technology provides professional software custom development services to meet the different needs of enterprise software products, and also provides high-quality software outsourcing services for customers.',
        text2: 'After years of accumulation of software development experience, Linglongta Technology provides high-quality custom development outsourcing services for customers in finance, circulation, retail, education, tourism and other industries, and has formed a complete set of mature software project development processes and quality assurance systems to ensure efficient and high-quality software development and on-time delivery.'
      },
      section3: {
        title: 'Software Development Business Process',
        steps: [
          { num: '01', title: 'Requirement Analysis', text: 'Customer proposes requirements and conducts requirement analysis, confirms requirements with customers repeatedly, and submits preliminary design' },
          { num: '02', title: 'System Design', text: 'Conduct outline design of the software, and conduct detailed design based on the outline design, generate design documents for developers to develop' },
          { num: '03', title: 'System Development', text: 'Start functional development of the software according to the detailed design document, so as to realize the requirements of the target system functions, interfaces, interfaces, etc.' },
          { num: '04', title: 'System Testing', text: 'The project team completes the unit test of the system, submits the test report to the customer, and then hands it over to the customer for trial use' },
          { num: '05', title: 'Software Delivery', text: 'After satisfactory testing, submit all products agreed in the contract to the customer, including source code, design report, test report, installation manual, user guide, etc.' },
          { num: '06', title: 'User Acceptance', text: 'Users accept according to the requirement document and bid, and settle the final account' }
        ]
      },
      section4: {
        title: 'Custom Development Service Scope',
        tabs: ['B/S Software Custom Development', 'WeChat Development', 'Mobile App Development'],
        cards: [
          { title: 'B/S Software Custom Development', text: 'Professional customization of various software, including operation and maintenance management system, OA office system, CRM system, asset management system, examination management system, school enrollment system, etc.' },
          { title: 'WeChat Development', text: 'Professional customization of WeChat official accounts (enterprise account/service account), WeChat mini programs, micro official website, micro mall, WeChat payment function, WeChat interface and other development customization' },
          { title: 'Mobile App Development', text: 'IOS, Android APP development, iPhone, iPad, Android mobile phone Android tablet, APP native development, HtmI5 development, mobile website development, etc.' }
        ],
        tryFree: 'Free Trial'
      },
      section5: {
        title: 'Software Testing Service'
      },
      section6: {
        title: 'Operation Service Pattern',
        subTitle: 'Offshore Development Center (ODC) Operation',
        text1: 'In the form of an upgraded version of outsourced work orders, after establishing a period of cooperation and trust between the two parties, we can develop task work orders at our own site. For enterprises, this will reduce remote management costs and can also reduce work order quotations accordingly.',
        text2: 'Linglongta Technology\'s ODC is built according to strict international security standards and customer internal policy requirements on personnel, data, infrastructure, intellectual property rights, etc., with the aim of ensuring maximum security protection of customer intellectual property rights.',
        cards: [
          {
            title: 'Customer-Managed ODC',
            text: 'In this model, we provide project managers, programmers and required hardware facilities. The customer is responsible for software architecture design and managing the entire software development process. During the development process, we will request the customer to provide relevant business information, business processes, quality management, technical resources and other information according to the needs of development. This ODC model is based on a partnership between the two parties and requires wholehearted dedication from both parties'
          },
          {
            title: 'Our-Managed ODC',
            text: 'In this model, the customer company only needs to propose requirements, and we will provide you with requirement analysis, complete the design of the solution, and complete all subsequent development and testing until the project is successfully delivered to the customer for use. Throughout the development process, we not only provide technical personnel and hardware equipment, but also are responsible for comprehensive management'
          },
          {
            title: 'Build-Operate-Transfer ODC',
            text: 'In this model, we establish an ODC according to customer requirements based on a bilateral agreement, including the purchase of hardware facilities, recruitment and training of software technical personnel, and manage the ODC for a period of time. When the customer is ready, the ODC will be transferred to the customer for independent management, including all equipment, technical personnel and our management experience'
          }
        ]
      },
      softwareTest:[
        {
          title: 'Functional Testing',
          tests: ['Functional Verification', 'Reverse Testing', 'Process Testing', 'Fault Tolerance Testing']
        },
        {
          title: 'Performance Efficiency Testing',
          tests: ['Load Testing', 'Stress Testing', 'Fatigue Strength Testing', 'Concurrency Testing']
        },
        {
          title: 'Security Testing',
          tests: ['Confidentiality', 'Integrity', 'Auditability', 'Authenticity', 'Non-repudiation']
        },
        {
          title: 'Reliability Testing',
          tests: ['Maturity', 'Availability', 'Fault Tolerance', 'Recoverability']
        },
        {
          title: 'Other Testing',
          tests: ['Compatibility Testing', 'Usability Testing', 'Maintainability Testing', 'Portability Testing', 'Documentation Testing']
        }
      ]
    },
    tonePage: {
      section1: {
        title: 'Tone Intelligent Development Platform',
        description: 'Based on Linglongta Technology\'s deep exploration of large-scale parameters and deep learning capabilities, Tone provides enterprises with a more intelligent software production method. IT personnel can easily achieve full-stack low-code application building from "intelligent generation" to "visual drag-and-drop adjustment", making complex application development more efficient and accelerating enterprise digitalization and intelligence processes.',
        consultBtn: 'Free Consultation with Architect'
      },
      section2: {
        title: 'Business Digitalization, All Low-Code',
        cards: [
          {
            title: 'Intelligent Programming',
            text: 'Machine learning is one of the key technologies of intelligent programming. Through machine learning, computers can gradually learn developers\' intentions and requirements, thereby better understanding the code requirements expressed by users. In this way, developers only need to describe their requirements in concise natural language, and the intelligent programming system will automatically generate corresponding code for them.'
          },
          {
            title: 'Intelligent Interaction',
            text: 'Provides intelligent interaction components, using natural language to generate code technology, allowing users to achieve instant intelligent queries, smooth intelligent interactions, and lead intelligent innovation experiences.'
          }
        ]
      },
      section3: {
        title: 'Change Enterprise Software Production Methods',
        consultBtn: 'Free Consultation with Architect',
        stats: [
          { percent: '60%', label1: 'Reduce', label2: 'Full-Link Software Development Costs' },
          { percent: '50%', label1: 'Average Shorten', label2: 'Project Delivery Cycle' }
        ]
      },
      section4: {
        title: 'Low-Code VS Zero-Code'
      },
      section5: {
        title: 'Why Choose Tone Intelligent Development Platform',
        cards: [
          {
            title: 'High-Fidelity Interactive Visual Requirements',
            text: 'Openness gives it higher customization capabilities, can high-fidelity restore interactive visual requirements, break through enterprise custom demand development limitations and other problems'
          },
          {
            title: 'High Integrability',
            text: 'Supports integration with customer-owned or third-party databases, file storage, authentication sources, APIs, etc., can achieve interconnection of application development assets, break through barriers between low-code platforms and enterprise software ecosystems'
          },
          {
            title: 'Strong Scalability',
            text: 'Supports flexible expansion of platform capabilities through custom extension components or blocks, developing new components, replacing component libraries, etc.'
          },
          {
            title: 'Financial-Grade Security Requirements',
            text: 'Provides application source code, no black-box engine, ensures code-level security of applications'
          },
          {
            title: 'Good at Complex Application Development',
            text: 'Provides a large number of standardized components and complete logic components and process frameworks to help large and medium-sized enterprises build key applications and complex core systems at low cost and quickly'
          },
          {
            title: 'Support Application Export',
            text: 'Provides application export and independent deployment capabilities, supports exporting application source code and deploying to other environments outside the platform'
          }
        ]
      },
      section6: {
        title: 'Core Product Functions',
        tabs: ['Page Design', 'Process Design', 'Form Design', 'API Integration'],
        cards: [
          {
            title: 'Page Design',
            text: 'Customize page style, display all form data of the application, flexibly implement information display, navigation, portal pages and other scenarios'
          },
          {
            title: 'Process Design',
            text: 'Integrated process engine supports business process development under BPMN2.0 specification, and has standardized models and symbols. It can quickly develop common internal enterprise processes, such as leave, onboarding, offboarding, etc.'
          },
          {
            title: 'Form Design',
            text: 'Rich field types, powerful data linkage, related forms, formula calculations and other capabilities to achieve flexible low-code visual design and page building'
          },
          {
            title: 'API Integration',
            text: 'Enterprise existing interfaces can be quickly imported into the low-code platform and automatically accessed to the API gateway. The platform provides visual interface definition functions that can automatically connect interfaces to the API gateway.'
          }
        ],
        tryFree: 'Free Trial'
      },
      section7: {
        title: 'Popular Application Scenarios',
        cards: [
          {
            title: 'Component/Service Accumulation and Reuse',
            text: 'Scientifically sort out the core business of the enterprise, front-end component libraries and domain services have been high-quality accumulated, forming effective asset management, thereby achieving cost reduction and efficiency improvement'
          },
          {
            title: 'Extend Core System Functions',
            text: 'Provide flexible application integration extension capabilities through API gateway, can reduce technical difficulties in maintenance and implementation, ensure system continuity and stability, guarantee software quality'
          },
          {
            title: 'Business Process Automation',
            text: 'Provide standard workflow engine to realize business process automation, can improve team internal collaboration efficiency, reduce enterprise costs, create good user experience, improve user satisfaction'
          },
          {
            title: 'Business Rehearsal/Feasibility Analysis',
            text: 'Quickly combine and expand based on existing enterprise business capabilities, and adjust business in a timely, fast and flexible manner according to market feedback to verify whether business innovation is reliable'
          }
        ]
      },
      section8: {
        title: 'Choose Linglongta Technology, Quickly Build Enterprise Low-Code Applications',
        consultBtn: 'Free Consultation with Architect'
      }
    },
    dataCenterPage: {
      section1: {
        title: 'Data Middle Platform Solution',
        description: 'After years of practice and refinement, Linglongta Technology has created an enterprise-level data middle platform full-link solution. This solution combines excellent methodology and leading product capabilities, committed to helping enterprises achieve digital transformation, fully leverage the value of data, and improve enterprise data productivity.',
        consultBtn: 'Free Consultation with Architect'
      },
      section2: {
        title: 'Solution Features',
        cards: [
          {
            title: 'Unified Data Standards',
            text: 'Eliminate data ambiguity, adopt a combination of data standard system construction methodology and data indicator system to unify data indicator caliber'
          },
          {
            title: 'Unified Data Services',
            text: 'Unify external data service interfaces, integrate all data services into one interface'
          },
          {
            title: 'Unified Data Asset Management',
            text: 'Provide a data asset management platform suitable for enterprises, achieve 360° tracking of the entire data link through data map and data lineage functions'
          },
          {
            title: 'Unified Development Platform',
            text: 'Provide a visual, drag-and-drop self-service development and analysis platform, unify data development processes and project cycle management'
          }
        ]
      },
      section3: {
        title: 'Solution Architecture'
      },
      section4: {
        title: 'Core Functions',
        tabs: ['Agile Development Platform', 'Unified Query Service', 'Data Asset Management', 'Data Quality Center'],
        cards: [
          {
            title: 'Agile Development Platform',
            text: 'We provide a one-stop big data management and application development platform that can meet various needs of enterprise-level big data application scenarios, including large-scale data storage and computing, data integration, task development, analysis and query, data management and project management.'
          },
          {
            title: 'Unified Query Service',
            text: 'We provide easy-to-use, low-cost, stable and reliable data open sharing services to help front-end businesses quickly access.'
          },
          {
            title: 'Data Asset Management',
            text: 'Comprehensive monitoring and recording of computing and storage resource consumption for projects, personnel, tasks, tables, and queues. Inventory and plan resources to reduce data management costs and track data value.'
          },
          {
            title: 'Data Quality Center',
            text: 'To improve enterprise data quality, we need to monitor and analyze around completeness, accuracy, consistency and timeliness. Focus on full-link lineage tracking of data access, data processing, data export, indicators and data applications to predict whether data can be produced on time, understand impact analysis after task failure and quickly repair.'
          }
        ],
        tryFree: 'Free Trial'
      },
      section5: {
        title: 'Solution Value',
        cards: [
          {
            title: 'Improve Data Service Efficiency',
            text: 'Achieve triple improvement in requirement delivery speed, data search efficiency, and data query capability'
          },
          {
            title: 'Improve Data Quality',
            text: 'Achieve zero latency of task data, while significantly reducing the number of R&D bugs, and complete the unification of data indicator caliber'
          },
          {
            title: 'Reduce Data Service Costs',
            text: 'Significantly save business costs and improve overall R&D business value'
          },
          {
            title: 'Ensure Business Data Security',
            text: 'Ensure business data security through data management measures such as full-link permission control, automatic approval processes, automatic risk identification, and intelligent data desensitization'
          }
        ]
      },
      section6: {
        title: 'Combine Business Needs, Learn More About Solution Details',
        consultBtn: 'Free Consultation with Architect'
      }
    },
    aiPage: {
      section1: {
        title: 'Artificial Intelligence Solution',
        description: 'This platform is built through high-performance computing architecture and big data underlying platform, aiming to provide AI developers with a one-stop, high-performance analysis and modeling platform. The platform functions cover the entire process of algorithm development, model training evaluation, and online inference prediction modeling. It can effectively support various data intelligent analysis scenarios and provide strong support for enterprise AI transformation and upgrading.',
        consultBtn: 'Free Consultation with Architect'
      },
      section2: {
        title: 'In-depth Research on Algorithm Modeling Scenarios, Provide Comprehensive AI Transformation Support for Enterprises',
        cards: [
          {
            title: 'Complex Model Engineering',
            painPoint: 'In the traditional model, after modeling personnel complete model training, they need to coordinate with the engineering team to complete model deployment, which leads to higher overall modeling costs',
            solution: 'The machine learning platform simplifies engineering tasks such as task scheduling and model deployment. Model deployment can be completed with just one click, achieving rapid application of trained models to business, saving costs and improving efficiency'
          },
          {
            title: 'Low Computing Efficiency',
            painPoint: 'In massive data scenarios, AI analysts often ignore hardware and computing framework considerations while focusing on business efficiency modeling, resulting in decreased model training efficiency',
            solution: 'Our machine learning platform integrates distributed computing frameworks such as TensorFlow and Spark, and is deeply optimized to meet the needs of large-scale sparse scenarios, providing efficient modeling capabilities'
          },
          {
            title: 'Unified Data Asset Management',
            painPoint: 'The machine learning modeling process is very complex. It not only requires in-depth understanding of algorithm principles, but also requires in-depth research on business. Traditional data analysts are difficult to quickly competent',
            solution: 'The machine learning platform has easy-to-use visual modeling functions, abstracts complex algorithms into operators, supports drag-and-drop interaction, and can quickly build modeling processes'
          }
        ],
        labels: {
          painPoint: 'Pain Point',
          solution: 'Solution & Features'
        }
      },
      section3: {
        title: 'Product Advantages',
        cards: [
          {
            title: 'One-Stop Modeling',
            text: 'Improve modeling efficiency, provide one-stop solution, covering data management, feature engineering, model development and debugging, offline model training and online model inference modeling'
          },
          {
            title: 'High-Performance Computing',
            text: 'We integrate and optimize computing frameworks such as Pytorch, Spark, and TensorFlow, and build in scenario-based operators to effectively support advertising, recommendation and other scenario applications'
          },
          {
            title: 'Low Inference Latency',
            text: 'Utilize network bandwidth and backend engine computing capabilities to fully achieve millisecond-level precise ranking model calculations to meet scenarios that require low latency such as recommendation and search'
          },
          {
            title: 'Low-Threshold Modeling',
            text: 'To meet users\' programming habits, we have encapsulated functions such as model scheduling, model version updates and model monitoring to help users perform model tuning and production release more quickly'
          }
        ]
      },
      section4: {
        title: 'Popular Application Scenarios',
        tabs: ['Time Series Prediction', 'Marketing Recommendation', 'Operation Decision Optimization'],
        cards: [
          {
            title: 'Time Series Prediction',
            text: 'Time series prediction scenarios are necessary conditions and foundations for intelligent decision-making. We use historical data to fully explore the correlations of relevant factors, gain insights into time series trends and cycles, and apply time series prediction algorithms for trend prediction to help business take avoidance measures before operational risks appear.'
          },
          {
            title: 'Marketing Recommendation',
            text: 'By integrating user information, order information, logistics information, product information and real-time click behavior data sets, we can build a 360° portrait of personnel. Through this portrait, achieve accurate matching of user interests and product labels, thereby recalling effective product sets, and refine product sorting of recalled results to achieve customized product marketing in Internet scenarios.'
          },
          {
            title: 'Operation Decision Optimization',
            text: 'Taking supply chain decision optimization as an example, we can abstract warehousing distribution, transportation scheduling, inventory strategy, order replenishment strategy and overall supply chain operations optimization into modeling processes. Through platform-based modeling and computing capabilities, improve the intelligence level of business decisions and achieve refined enterprise management.'
          }
        ],
        tryFree: 'Free Trial'
      },
      section5: {
        title: 'Core Capabilities',
        cards: [
          {
            title: 'Visual Modeling',
            text: 'Abstract the modeling process into operators, allowing users to build modeling processes through drag-and-drop interaction. At the same time, support experiment-level control to achieve team collaboration modeling'
          },
          {
            title: 'Data Management',
            text: 'A unified data management center that can manage data from various sources, including structured and unstructured data, and supports data collection, data labeling and data insight functions'
          },
          {
            title: 'Online Inference Prediction',
            text: 'Provide online environment prediction services, can quickly deploy offline models, and provide high-concurrency, low-latency inference services. At the same time, it also supports model smooth upgrade, elastic scaling and model failure monitoring functions'
          },
          {
            title: 'Interactive Modeling',
            text: 'Provide a model development environment with immersive programming experience, support TensorFlow, PyTorch, Spark and other computing frameworks, support one-click submission of training tasks'
          }
        ]
      },
      section6: {
        title: 'Relying on AI Large Model Technology, Help Business Mine Data Value Faster, More Conveniently and More Intelligently',
        consultBtn: 'Free Consultation with Architect'
      }
    },
    homeScheme: {
      solution: 'Solutions',
      solutionText: 'SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION SOLUTION',
      cards: [
        {
          title: 'Low-Code',
          content: 'Linglongta Technology has an independent product R&D team and has occupied an advanced position in the industry after large-scale customer verification. Provides high-quality packaged applications that can be directly implemented, achieving higher satisfaction while reducing requirement risks and open costs. Using advanced Low-Code visual technology, high-experience new applications can be built in weeks, accelerating enterprise operational innovation and digital transformation.',
          viewDetail: 'View Details',
          link: '/option/tone'
        },
        {
          title: 'Data Service Center',
          content: 'The Data Service Center integrates one-stop, intelligent, platform-based, and service-oriented capabilities, aiming to utilize the computing, storage, and expansion capabilities of the big data platform to help organizations achieve high-level data integration and data capability reuse in the digital construction process. Focusing on the four directions of strengthening platforms, governing data, building services, and touching scenarios, it helps enterprises achieve digital intelligence transformation and realize the entire process from business data to data services.',
          viewDetail: 'View Details',
          link: '/option/datacenter'
        },
        {
          title: 'Artificial Intelligence',
          content: 'Based on AI technology, provide enterprise intelligent solutions suitable for various scenarios, including: virtual digital humans, language intelligent control, AI middle platform, large screen optimization, data middle platform, intelligent cloud review for collection and procurement, intelligent meetings, smart work badges, intelligent reconciliation and accounting and other digital solutions; intelligent recruitment, electronic contracts, intelligent translation, intelligent accounting, AI subtitles, etc.',
          viewDetail: 'View Details',
          link: '/option/ai'
        }
      ]
    },
    reservationPage: {
      company: {
        name: 'Linglongta Technology',
        subtitle: 'Enterprise Digital Transformation Accelerator',
        features: ['High Technology', 'Innovative', 'Win-win with Customers']
      },
      form: {
        title: 'Get Solutions',
        description: 'Thank you for choosing Linglongta Technology. We will arrange professional consultants to demonstrate the product to you, reducing the time spent exploring the software. Please fill in the information below to start efficient work.',
        fields: {
          designation: {
            placeholder: 'Your Name (Required)',
            required: 'Name cannot be empty.'
          },
          companyName: {
            placeholder: 'Company Name (Required)',
            required: 'Company name cannot be empty.'
          },
          duties: {
            placeholder: 'Your Position (Required)',
            required: 'Position cannot be empty.'
          },
          phone: {
            placeholder: 'Your Phone (Required)',
            required: 'Phone number cannot be empty.',
            invalid: 'Please enter a valid phone number.'
          },
          leaveMessage: {
            placeholder: 'Please enter your message here, we will contact you as soon as possible',
            required: 'Please enter your message.'
          }
        },
        submit: 'SUBMIT'
      }
    },
    newsPage: {
      pageTitle: 'News & Events',
      viewMore: 'View More',
      noData: '--'
    }
  }
}

// ⚠️ Vue 3 使用 createI18n
const i18n = createI18n({
  legacy: false,  // ⚠️ 必须设置为 false 以使用 composition API
  locale: savedLocale,
  fallbackLocale: 'zh',
  messages,
  globalInjection: true,
  silentFallbackWarn: false,
  silentTranslationWarn: false
})

// console.log('====== i18n 初始化完成 ======')
// console.log('locale:', i18n.global.locale.value)
// console.log('messages:', Object.keys(i18n.global.messages.value))
// console.log('t("nav.home"):', i18n.global.t('nav.home'))
// console.log('===========================')

export default i18n